import { getMyCoupons } from "./getMyCoupons";
import store from "@/store/index";

export const getCouponWithId = async (id) => {
  try {
    const coupons = await getMyCoupons();
    const targetData = coupons.find((data) => data.id == id);

    console.log("getCouponWithId response.data :>> ", targetData);
    store.commit("MFITT/setSelectedCoupon", targetData);
    return targetData;
  } catch (err) {
    console.log('ERROR"" getCouponWithId():', err);
    throw err;
  }
};
